import React from "react";
import "./../host.css"; // If you want to add custom media queries

const DashboardCustomerStats = ({ stats }) => (
  <div
    className="rounded-4 h-100 d-flex flex-column justify-content-center dashboard-customer-stats"
    style={{ background: "#4ed6e6" }}
  >
    {[
      { label: "NEW", value: stats?.newCustomers || 0 },
      { label: "RETURNING", value: stats?.returningCustomers || 0 },
    ].map((item, idx) => (
      <div
        key={item.label}
        className={`d-flex flex-column flex-md-row align-items-center customer-stats-row${idx === 0 ? "" : ""
          }`}
        style={{ minHeight: 60 }}
      >
        <div
          className="bebas customer-stats-value"
          style={{
            color: "#fff",
            minWidth: 60,
            textAlign: "right",
            fontSize: 40,
            fontWeight: 500
          }}
        >
          {item.value}
        </div>
        {/* Divider: vertical on desktop, horizontal on mobile */}
        <div
          className="d-none d-md-block"
          style={{
            width: 2,
            height: 48,
            background: "#595959",
            margin: "0 18px",
          }}
        />
        <div
          className="d-block d-md-none"
          style={{
            width: 40,
            height: 2,
            background: "#595959",
            margin: "12px 0",
          }}
        />
        <div
          className="lato-bold-16 text-uppercase customer-stats-label"
          style={{ color: "#595959", textAlign: "left" }}
        >
          {item.label}
          <br />
          CUSTOMERS
        </div>
      </div>
    ))}
  </div>
);

export default DashboardCustomerStats;